/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ReactElement } from "react";

import {
  CHANNEL_LOGOS,
  getCountryRoutes,
  getMediaTagsByType,
  IMediaCategoryModel,
} from "@nf/common";
import { AppConfig, IS_CHILD_COOKIE } from "@nf/constants";
import { GetServerSideProps } from "next";
import { NextSeo } from "next-seo";

import type {
  Channel,
  SearchScreenProps,
} from "screens/SearchScreen/SearchScreen";

import Layout from "layouts/Layout";
import SearchScreen from "screens/SearchScreen";

import styles from "screens/SearchScreen/SearchScreen.module.scss";

export const getServerSideProps: GetServerSideProps<SearchScreenProps> = async (
  ctx
) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);
  const countryRoutes = getCountryRoutes(commonProps.country);

  const cookies = ctx.req.cookies;
  const isChild = cookies?.[IS_CHILD_COOKIE] === "true";

  const mediaCategories = await DataProvider.getMediaCategories(true);
  let genreList: IMediaCategoryModel[] = [];

  if (mediaCategories) {
    genreList = getMediaTagsByType(mediaCategories.Entities);
  }

  const CHANNELS: Channel[] = [];

  if (countryRoutes.HOME) {
    CHANNELS.push({
      url: countryRoutes.HOME,
      icon: CHANNEL_LOGOS[countryRoutes.HOME.slice(1)]
        ? CHANNEL_LOGOS[countryRoutes.HOME.slice(1)]?.labeled
        : "",
      ageRestricted: true,
    });
  }

  if (countryRoutes.DANSK) {
    CHANNELS.push({
      url: countryRoutes.DANSK,
      icon: CHANNEL_LOGOS[countryRoutes.DANSK.slice(1)]
        ? CHANNEL_LOGOS[countryRoutes.DANSK.slice(1)]?.labeled
        : "",
      ageRestricted: true,
    });
  }

  if (countryRoutes.KIDS) {
    CHANNELS.push({
      url: countryRoutes.KIDS,
      icon: CHANNEL_LOGOS[countryRoutes.KIDS.slice(1)]
        ? CHANNEL_LOGOS[countryRoutes.KIDS.slice(1)]?.labeled
        : "",
      ageRestricted: true,
    });
  }

  return {
    props: {
      ...commonProps,
      enableRecommendations: !isChild,
      genreList,
      channels: CHANNELS.filter((channel) => {
        if (isChild && channel.ageRestricted) {
          return false;
        }
        return true;
      }),
    },
  };
};

const SearchScreenWrapper = (props: SearchScreenProps) => {
  return <SearchScreen {...props} />;
};

SearchScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout config={props?.config} className={styles.layout}>
      <NextSeo nofollow />
      {page}
    </Layout>
  );
};

export default SearchScreenWrapper;
